import { PlatformLogo } from "@/components/PlatformLogo";
import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";
import ArrowRight from "atoms/icon/icons/arrow_right.svg";

import { PersonalisationAIAdvisorAvatar } from "./PersonalisationAIAdvisorAvatar";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface AdonisIdentity {
  name: string;
  avatarUrl: string;
}

interface PlatformDetails {
  logoSrc: string;
  platformName: string;
}

interface YouAreNotAloneProps {
  adonisIdentity: AdonisIdentity;
  platformDetails: PlatformDetails;
  onNext?: () => void;
}

export const YouAreNotAlone = ({
  adonisIdentity,
  platformDetails,
  onNext,
}: YouAreNotAloneProps) => {
  const { t } = useTranslation();
  return (
    <PersonalisationScreenLayout
      footerClassName="flex w-full items-center justify-end px-8 pb-4"
      footer={
        <Button
          style="primary"
          size="large"
          onClick={onNext}
          endIconSVG={ArrowRight}
          iconSize="xsmall"
        >
          {t("common.next")}
        </Button>
      }
      contentClassName="pt-[46px]"
    >
      <div className="flex items-center justify-center">
        <PlatformLogo
          logoUrl={platformDetails.logoSrc}
          platformName={platformDetails.platformName}
        />
      </div>

      <PersonalisationAIAdvisorAvatar
        avatarUrl={adonisIdentity.avatarUrl}
        name={adonisIdentity.name}
      />

      <p className="font-serif text-[24px] italic leading-8 text-[var(--Primary-Text,#091F24)]">
        {t("youAreNotAlone.messageLine1")}
        <br />
        <br />
        {t("youAreNotAlone.messageLine2")}
      </p>
    </PersonalisationScreenLayout>
  );
};
